import { useCallback } from 'react';
import { useRegisterMutation } from 'graphql/types';
import { AUTH_TOKEN } from 'constant';
import LocalStore from 'helpers/localStore';

import { RegisterReq } from 'services/auth';

function useRegister() {
  const [userRegister, { loading }] = useRegisterMutation();
  const register = useCallback(
    async (
      data: RegisterReq,
      onSuccess: () => void = () => {},
      onError?: (errorMessage: string) => void,
    ) => {
      try {
        const result = await userRegister({
          variables: { input: data },
        });
        const token = result?.data?.register?.jwt;
        if (!token) {
          throw new Error('Application received successfully! Please wait for approval.');
        }
        LocalStore.set(AUTH_TOKEN, token);
        onSuccess();
      } catch (err) {
        LocalStore.remove(AUTH_TOKEN);
        if (err instanceof Error) {
          onError?.(err.message);
        }
      }
    },
    [userRegister],
  );
  return [loading, register] as const;
}

export default useRegister;
